export const SOUND_FILES = {
  correct_decision: require('../Assets/sounds/correct_decision.mp3'),
  wrong_decision: require('../Assets/sounds/wrong_decision.mp3'),
  hint_used: require('../Assets/sounds/hint_used.mp3'),
  timer_tick: require('../Assets/sounds/timer_tick.mp3'),
};
